
import React, { useMemo } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { BLOG_POSTS } from '../data';

export const BlogDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  
  const post = useMemo(() => BLOG_POSTS.find(p => p.slug === slug), [slug]);

  if (!post) {
    return (
      <div className="max-w-[1400px] mx-auto px-4 py-32 text-center bg-white">
        <h1 className="text-5xl font-black mb-10 text-brand-deep tracking-tighter">Raksts nav atrasts</h1>
        <Link to="/blogs" className="bg-brand-accent text-white px-12 py-5 rounded-full font-black text-xs uppercase tracking-widest">Atpakaļ uz blogu</Link>
      </div>
    );
  }

  return (
    <div className="bg-white pb-32">
      {/* Breadcrumbs */}
      <div className="bg-brand-surface py-5 border-b border-brand-surface">
        <div className="max-w-[1400px] mx-auto px-4 text-[10px] font-black uppercase tracking-widest text-brand-deep/40 flex gap-4 items-center">
          <Link to="/" className="hover:text-brand-accent transition-colors">Sākums</Link>
          <i className="fas fa-chevron-right text-[8px] opacity-20"></i>
          <Link to="/blogs" className="hover:text-brand-accent transition-colors">Blogs</Link>
          <i className="fas fa-chevron-right text-[8px] opacity-20"></i>
          <span className="text-brand-deep font-black truncate">{post.title}</span>
        </div>
      </div>

      <article className="max-w-6xl mx-auto px-4 mt-20">
        <header className="mb-16 text-center">
          <div className="inline-block bg-orange-50 text-brand-accent px-5 py-2 rounded-full text-[10px] font-black uppercase tracking-[0.2em] mb-8 border border-orange-100">
            {post.category}
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-brand-deep tracking-tighter leading-tight mb-8">
            {post.title}
          </h1>
          <div className="flex items-center justify-center gap-6 text-[10px] font-black uppercase tracking-widest text-brand-deep/40">
            <span>{post.date}</span>
            <div className="w-1.5 h-1.5 bg-brand-accent rounded-full"></div>
            <span>{post.author}</span>
          </div>
        </header>

        <div className="rounded-2xl overflow-hidden shadow-2xl mb-20 border-[12px] border-white ring-1 ring-brand-surface">
          <img src={post.image} className="w-full h-auto object-cover aspect-[16/9]" alt={post.title} />
        </div>

        <div className="prose prose-xl max-w-none text-brand-deep/90 leading-relaxed font-medium space-y-10">
          <p className="text-2xl font-black text-brand-deep italic leading-relaxed">
            {post.excerpt}
          </p>
          <div className="w-20 h-1.5 bg-brand-accent rounded-full"></div>
          <p>
            {post.content}
          </p>
          <p>
            Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Nulla porttitor accumsan tincidunt. Donec rutrum congue leo eget malesuada.
          </p>
          <p>
            Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.
          </p>
        </div>

        <footer className="mt-24 pt-12 border-t border-brand-surface flex flex-col md:flex-row justify-between items-center gap-8">
          <button 
            onClick={() => navigate('/blogs')}
            className="flex items-center gap-4 text-brand-deep font-black uppercase text-xs tracking-[0.2em] hover:text-brand-accent transition-colors group"
          >
            <i className="fas fa-arrow-left text-[10px] group-hover:-translate-x-2 transition-transform"></i> Atpakaļ uz sarakstu
          </button>
          
          <div className="flex gap-4">
            <span className="text-[10px] font-black uppercase tracking-widest text-brand-deep/30 pt-1">Kopīgot:</span>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-brand-surface flex items-center justify-center text-brand-deep hover:bg-brand-accent hover:text-white transition-all"><i className="fab fa-facebook-f text-xs"></i></a>
              <a href="#" className="w-8 h-8 rounded-full bg-brand-surface flex items-center justify-center text-brand-deep hover:bg-brand-accent hover:text-white transition-all"><i className="fab fa-twitter text-xs"></i></a>
              <a href="#" className="w-8 h-8 rounded-full bg-brand-surface flex items-center justify-center text-brand-deep hover:bg-brand-accent hover:text-white transition-all"><i className="fab fa-whatsapp text-xs"></i></a>
            </div>
          </div>
        </footer>
      </article>
    </div>
  );
};
